import { NavLink, Outlet } from 'react-router';
import { useAuth } from '../features/auth/auth-context.js';
import { CurrencySwitcher } from '../features/currency/CurrencySwitcher.js';

/** Phase order from the spec — later phases are visible but clearly not ready. */
const NAV_ITEMS = [
  { to: '/', label: 'Áttekintés', end: true },
  { to: '/portfolio', label: 'Portfólió', end: false },
  { to: '/spending', label: 'Költés', end: false },
  { to: '/budget', label: 'Budget', end: false },
  { to: '/investment-day', label: 'Befektetési nap', end: false },
  { to: '/settings', label: 'Beállítások', end: false },
] as const;

export function AppShell() {
  const { user, signOut } = useAuth();

  return (
    <div className="shell">
      <header className="shell__header">
        <span className="shell__brand">Budget</span>
        <div className="shell__actions">
          <CurrencySwitcher />
          <button
            type="button"
            className="button button--ghost"
            onClick={() => void signOut()}
            title={user?.email ?? undefined}
          >
            Kilépés
          </button>
        </div>
      </header>

      <nav className="shell__nav" aria-label="Fő navigáció">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `shell__nav-link${isActive ? ' is-active' : ''}`}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <main className="shell__main">
        <Outlet />
      </main>
    </div>
  );
}
